import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  analyticsPaper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
    padding: '12px 16px',
  },
  statsContainer: {
    borderRadius: '0px',
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  exportDataBtnContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '12px',
    gap: '4px',
    '@media (min-width: 640px)': {
      paddingTop: '0px',
      width: 'unset',
    },
  },
  exportDataBtn: {
    height: '44px',
    padding: '10px 16px 10px 12px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '&>.myev-MuiButton-label': {
      gap: '8px',
      justifyContent: 'center',
    },
  },
  tabList: {
    display: 'flex',
    flexDirection: 'row',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
    width: '100%',
    '.myev-MuiTabs-flexContainer': {
      flexDirection: 'column',
    },
  },
  tabElement: {
    height: '40px',
    fontWeight: 600,
    fontSize: '10px',
    textTransform: 'uppercase',
    flex: 1,
    maxWidth: '100%',
    minWidth: 'unset',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    '&>.myev-MuiTab-wrapper': {
      alignItems: 'flex-start',
    },
    '&.Mui-selected': {
      backgroundColor: theme.evPalette.ocean[100],
      borderBottom: `2px solid ${theme.evPalette.ocean[600]}`,
    },
    '&:hover': {
      backgroundColor: theme.evPalette.ocean[100],
    },
    '&.lastElement': {
      borderRight: '0px',
      borderBottom: '0px',
    },
    '@media (min-width: 640px)': {
      width: '100%',
      borderRight: `1px solid ${theme.evPalette.charcoal[400]}`,
      borderBottom: '0px',
    },
  },
  indicator: {
    display: 'none',
  },
  chartsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '24px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
}));
